module.exports = __webpack_public_path__ + "uKAwi6M3jJIjqSQpK/rdc_pro_logo.svg";